export const frontmatter = {
    "draft": true,
    "title": "WhatsApp Integration",
    "description": "Configure the WhatsApp integration in OnnIA to send and receive messages.",
    "sidebar_label": "WhatsApp",
    "sidebar_group": "guides",
    "sidebar_order": 1
}

export const toc = []